"use client";

import { motion } from "framer-motion";
import { Send, MessageCircle, Mail } from "lucide-react";
import Image from "next/image";

export default function ContactPage() {
  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-24">
      <motion.div 
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="text-center mb-16"
      >
        <h1 className="text-4xl md:text-6xl font-bold mb-6 tracking-tight drop-shadow-[0_4px_8px_rgba(0,0,0,0.8)]">
          随时与我们取得联系
        </h1>
        <p className="text-xl text-white/90 drop-shadow-[0_2px_4px_rgba(0,0,0,0.9)]">
          无论是技术接入、商务洽谈，还是定制开发需求，我们的专家团队 7x24 小时为您服务。
        </p>
      </motion.div>

      <motion.div 
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ delay: 0.2 }}
        className="glass-panel p-10 rounded-2xl border border-neon-cyan/30 shadow-[0_0_40px_rgba(0,243,255,0.1)] text-center relative overflow-hidden"
      >
        <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-neon-blue via-neon-cyan to-neon-magenta"></div>
        
        <div className="w-20 h-20 bg-black/50 rounded-full flex items-center justify-center mx-auto mb-8 border border-neon-cyan/50 shadow-[0_0_20px_rgba(0,243,255,0.2)]">
          <Send className="w-10 h-10 text-neon-cyan ml-1" />
        </div>

        <h2 className="text-3xl font-bold text-white mb-4">通过 Telegram 联系</h2>
        <p className="text-gray-300 mb-8 max-w-lg mx-auto">
          Telegram 是我们最推荐的沟通方式，您将获得最快的响应速度和端到端的加密沟通体验。
        </p>

        <div className="inline-block bg-black/60 border border-white/10 rounded-lg p-4 mb-8 backdrop-blur-md">
          <div className="flex items-center gap-3">
            <MessageCircle className="w-6 h-6 text-neon-cyan" />
            <span className="font-mono text-xl tracking-wider">@fade546</span>
          </div>
        </div>

        <div className="mb-10 flex justify-center">
          <div className="relative p-2 rounded-xl bg-gradient-to-b from-neon-cyan to-neon-blue shadow-[0_0_30px_rgba(0,243,255,0.4)]">
            <div className="relative w-48 h-48 rounded-lg overflow-hidden bg-white">
              <Image 
                src="/images/telegram-qr-new.jpg" 
                alt="Telegram QR Code for @fade546"
                fill
                className="object-cover"
                unoptimized
              />
            </div>
          </div>
        </div>

        <div>
          <a 
            href="https://t.me/fade546" 
            target="_blank" 
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 px-8 py-4 bg-neon-cyan/20 hover:bg-neon-cyan/40 border border-neon-cyan text-white font-bold rounded transition-all duration-300 shadow-[0_0_15px_rgba(0,243,255,0.3)] hover:shadow-[0_0_30px_rgba(0,243,255,0.6)]"
          >
            <Send className="w-5 h-5" />
            立即发起对话
          </a>
        </div>
      </motion.div>

      <div className="mt-16 grid grid-cols-1 md:grid-cols-2 gap-8 text-center">
        <div className="glass-panel p-6 rounded-xl border border-white/5">
          <Mail className="w-8 h-8 text-gray-400 mx-auto mb-3" />
          <h3 className="text-lg font-bold text-white mb-2">商务邮箱</h3>
          <p className="text-gray-400 text-sm">ZY7725984@outlook.com</p>
        </div>
        <div className="glass-panel p-6 rounded-xl border border-white/5">
          <MessageCircle className="w-8 h-8 text-gray-400 mx-auto mb-3" />
          <h3 className="text-lg font-bold text-white mb-2">备用频道</h3>
          <p className="text-gray-400 text-sm">点击右上角订阅官方新闻频道</p>
        </div>
      </div>
    </div>
  );
}
